module.exports = __webpack_public_path__ + "img/afa.8f5e8802.svg";